/* Wunschlisten-Drawer: laedt je gemerktem Produkt die Position (Section wishlist-item) nach, Warenkorb-Button oeffnet den Schnellkauf, Muelleimer entfernt den Eintrag. */

const root = () => window.Shopify?.routes?.root || '/';

class KgWishlistDrawer extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('kg-dialog');
    this.list = this.querySelector('[data-wishlist-list]');
    this.empty = this.querySelector('[data-wishlist-empty]');
    this.loading = this.querySelector('[data-wishlist-loading]');
    this.cache = new Map();

    this.onLinkClick = (event) => {
      const link = event.target.closest('[data-wishlist-link]');
      if (!link) return;
      event.preventDefault();
      this.dialog?.open(link);
    };
    document.addEventListener('click', this.onLinkClick);

    this.addEventListener('click', (event) => {
      const remove = event.target.closest('[data-wishlist-remove]');
      if (!remove) return;
      event.preventDefault();
      window.KGroup?.wishlist?.toggle(remove.dataset.wishlistRemove);
    });

    this.onUpdated = () => {
      if (this.dialog?.isOpen) this.render();
    };
    document.addEventListener('wishlist:updated', this.onUpdated);
    this.dialog?.addEventListener('dialog:open', () => this.render());
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onLinkClick);
    document.removeEventListener('wishlist:updated', this.onUpdated);
  }

  handles() {
    return window.KGroup?.wishlist?.read() || [];
  }

  async render() {
    const handles = this.handles();
    const request = (this.requestId = (this.requestId || 0) + 1);
    if (!handles.length) {
      this.list.replaceChildren();
      this.list.hidden = true;
      this.loading.hidden = true;
      this.empty.hidden = false;
      return;
    }
    this.empty.hidden = true;
    this.loading.hidden = handles.every((handle) => this.cache.has(handle));
    const items = await Promise.all(handles.map((handle) => this.load(handle)));
    if (request !== this.requestId) return;
    this.loading.hidden = true;
    const nodes = items.filter(Boolean);
    this.list.replaceChildren(...nodes);
    this.list.hidden = nodes.length === 0;
    this.empty.hidden = nodes.length > 0;
  }

  /* Kachel aus der Section wishlist-item holen; ein geloeschtes Produkt fliegt aus der Liste. */
  async load(handle) {
    if (this.cache.has(handle)) return this.cache.get(handle).cloneNode(true);
    try {
      const url = `${root()}products/${encodeURIComponent(handle)}?section_id=${encodeURIComponent(this.dataset.section)}`;
      const response = await fetch(url);
      if (response.status === 404) {
        window.KGroup?.wishlist?.toggle(handle);
        return null;
      }
      if (!response.ok) return null;
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const item = doc.querySelector('[data-wishlist-item]');
      if (!item) return null;
      this.cache.set(handle, item);
      return item.cloneNode(true);
    } catch {
      return null;
    }
  }
}

customElements.define('kg-wishlist-drawer', KgWishlistDrawer);
